module.exports = __webpack_public_path__ + "img/video.3a88b39.jpg";